import { styled } from '@mui/system';
import { MainCard } from '@components/BaseStyles';
import { Typography } from '@mui/material';

export const OrderSummaryCard = styled(MainCard, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant?: 'desktop' | 'simple' | 'fixed-bottom' }>(({ variant }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  padding: '24px',
  maxWidth: '360px',
  minWidth: '240px',
  ...(variant === 'simple' && {
    gap: '16px',
    width: '100vw',
    marginLeft: '-50vw',
    left: '50%',
    position: 'relative',
    borderRadius: '0px',
    maxWidth: '100vw',
  }),
  ...(variant === 'fixed-bottom' && {
    gap: '16px',
    width: '100vw',
    marginLeft: '-50vw',
    left: '50%',
    position: 'fixed',
    bottom: 0,
    zIndex: 1000,
    borderRadius: '0px',
    maxWidth: '100vw',
  }),
}));

export const OrderSummaryContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

export const OrderSummaryDataContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant?: 'desktop' | 'simple' | 'fixed-bottom' }>(({ variant }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '56px',
  ...(variant === 'simple' && {
    gap: '16px',
  }),
}));

export const OrderSummaryDetailContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

export const HorizontalContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export const SubtotalTypography = styled(Typography)({
  height: '21px',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '100%',
  letterSpacing: '0.16px',
});

interface DetailTypographyProps {
  bold?: boolean;
  lineThrough?: boolean;
}
export const DetailTypography = styled(Typography)<DetailTypographyProps>(
  ({ theme, bold }) => ({
    height: '21px',
    fontWeight: bold ? 500 : 400,
    fontSize: '13px',
    lineHeight: '100%',
    letterSpacing: '0.16px',
    color: bold ? theme.palette.text.primary : theme.palette.text.secondary,
  }),
);

export const DiscountSpan = styled('span')(({ theme }) => ({
  textDecoration: 'line-through',
  color: theme.palette.text.secondary,
  marginRight: '4px',
}));

export const TotalContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  borderTop: `1px solid ${theme.palette.divider}`,
  paddingTop: '12px',
}));

export const TotalTypography = styled(Typography)({
  height: '24px',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '100%',
  letterSpacing: '0.16px',
});
